import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Observable, throwError } from 'rxjs';

import { EmployeesService } from '../../../services/employees/employees.service';
import { select, Store } from '@ngrx/store';

import * as fromStore from '@unico-people/shared/dashboard/data-access-store';

import { filter, take } from 'rxjs/operators';

@Component({
  selector: 'app-form-colaborador',
  templateUrl: './dados-colaborador.component.html',
  styleUrls: ['./dados-colaborador.component.scss']
})
export class DadosColaboradorUpdateComponent implements OnInit {
  @Input() infos: any;
  @Input() colaboradorRef: any;

  @Output() reload: EventEmitter<boolean> = new EventEmitter<boolean>();

  departments$: Observable<any>;
  roles$: Observable<any>;
  units$: Observable<any>;

  vinculo: string;

  submittingForm: boolean;
  roles: any;
  roleName: string;
  departmentName: string;
  unitName: string;
  departments: any;
  roleSelected: any;
  minimumSchooling: any;
  schoolingChanged: boolean;
  roleChanged = false;
  departmentChanged = false;
  tempRole: boolean;
  tempDepartment: boolean;

  formDadosColaborador: FormGroup;

  constructor(private fb: FormBuilder, private employeesService: EmployeesService, private store: Store<fromStore.DashboardState>) {}

  ngOnInit(): void {
    this.createForm();
    this.loadSalary();
    this.loadRoles();
    this.loadUnits();
    this.loadDepartments();
  }

  createForm(): void {
    this.formDadosColaborador = this.fb.group({
      id: [this.infos?.id],
      salary: this.fb.group({
        value: ''
      }),
      email: [this.infos?.email],
      phone_number: this.fb.group({
        country_code: '55',
        number: ['']
      }),
      department: ['', [Validators.required]],
      role: ['', [Validators.required]],
      unit: ['', [Validators.required]]
    });
  }

  submitForm(form: FormGroup): void {
    const formValue = form?.value;
    this.submittingForm = true;

    const data = {
      id: this.infos?.id,
      name: this.infos?.name,
      email: formValue?.email,
      birthDate: formValue?.birthDate,
      role: formValue?.role,
      roleName: this.roleName,
      department: formValue?.department,
      departmentName: this.departmentName,
      unit: formValue?.unit,
      unitName: this.unitName,
      employeeCode: this.infos?.admission?.employeeCode,
      admission: {
        id: this.infos?.admission?.id,
        organizationID: this.infos?.admission?.organizationID,
        date: this.infos?.admission?.date,
        salary: formValue?.salary?.value.toString()
      }
    };

    this.employeesService.updateEmployee(data).subscribe(
      () => (this.reload.emit(true), (this.submittingForm = false)),
      err => {
        this.reload.emit(true), throwError(err);
      }
    );
  }

  loadSalary(): void {
    const salaryValue = this.infos?.admission?.salary ?? '0';
    this.formDadosColaborador.get('salary.value').setValue(salaryValue);
  }

  loadRoles(): void {
    this.store
      .select(fromStore.getAllRolesLoaded)
      .pipe(take(1))
      .subscribe(loaded => {
        if (!loaded) {
          this.store.dispatch(fromStore.loadAllRoles());
        }
        this.formDadosColaborador.get('role').setValue(this.infos.role);
      });

    this.store
      .pipe(
        select(fromStore.getPaginatedRoles),
        filter(roles => roles.length >= 1)
      )
      .subscribe(roles => {
        const roleUid = this.infos?.role;
        const defaultRole = {
          code: '01',
          name: 'Default Role',
          safedoc: '',
          uid: '1412d7fa-1905-43e5-92b7-f0b2c3699875'
          }
        roles = [defaultRole, ...roles]
        this.roleName = roles.filter(d => d?.uid === roleUid)[0]?.name;
      });

    this.roles$ = this.store.select(fromStore.getAllRoles);
  }

  loadDepartments(): void {
    this.store
      .select(fromStore.getAllDepartmentsLoaded)
      .pipe(take(1))
      .subscribe(loaded => {
        if (!loaded) {
          this.store.dispatch(fromStore.loadAllDepartments());
        }
        this.formDadosColaborador.get('department').setValue(this.infos.department);
      });

    this.store
      .pipe(
        select(fromStore.getPaginatedDepartments),
        filter(departments => departments.length >= 1)
      )
      .subscribe(departments => {
        const departmentUid = this.infos?.department;
        const defaultDeparment = {
          code: '01',
          name: 'Default Department',
          safedoc: '',
          uid: '89b5c543-50a0-47b3-abe4-77398b768142'
          }
        departments = [defaultDeparment, ...departments]
        this.departmentName = departments.filter(d => d?.uid === departmentUid)[0]?.name;
      });

    this.departments$ = this.store.select(fromStore.getAllDepartments);
  }

  loadUnits(): void {
    this.store
      .select(fromStore.getAllUnitsLoaded)
      .pipe(take(1))
      .subscribe(loaded => {
        if (!loaded) {
          this.store.dispatch(fromStore.loadAllUnits());
        }
        this.formDadosColaborador.get('unit').setValue(this.infos.unit);
      });

    this.store
      .pipe(
        select(fromStore.getPaginatedUnits),
        filter(units => units.length >= 1)
      )
      .subscribe(units => {
        const unitUid = this.infos?.unit;
        const defaultUnit = {
          code: '01',
          name: 'Default Unit',
          safedoc: '',
          uid: 'c73885d0-052a-458e-aa29-9f52470300d1'
          }

        this.unitName = units.filter(u => u?.uid === unitUid)[0]?.name;
      });

    this.units$ = this.store.select(fromStore.getAllUnits);
  }

  /**
   * Cancel form editing action by reseting form, loading the original information and closing the edition view
   */
  cancel($event: Event): void {
    this.formDadosColaborador.reset();
    this.loadSalary();
    this.loadRoles();
    this.loadUnits();
    this.loadDepartments();
    this.colaboradorRef.deactiveEdit($event);
  }
}
